import React from 'react'

import CurrentTeamMates from './current-team-mates'
import AddByEmail from './add-by-email'
import styles from '../component-styles/add-by-email.module.scss'

interface TeamMatesProps {
  className?: string
}

export default function TeamMatesSettings({ className }: TeamMatesProps) {
  return (
    <div className={className}>
      <h3>Add users</h3>
      <p className={styles.byline}>
        Enter an email address to send a new user a registration email or to add
        an existing user to additional accounts.
      </p>
      <AddByEmail />
      <h3>Current users</h3>
      <CurrentTeamMates />
    </div>
  )
}
